import useSectionSummaryAnswerLineStyles from './UseSectionSummaryAnswerLineStyles';
import useSectionSummaryStyles from './UseSectionSummaryStyles';

export {
	useSectionSummaryAnswerLineStyles,
	useSectionSummaryStyles,
};